// extracted by mini-css-extract-plugin
export default {"employee-container":"LoanRequest_employee-container__cE-fg","loan-header":"LoanRequest_loan-header__52Os7","loan-header__buttons":"LoanRequest_loan-header__buttons__Gtp5x"};